
import Hero from "@/components/Hero";
import Features from "@/components/Features";
import Gallery from "@/components/Gallery";
import BookingForm from "@/components/BookingForm";
import Navigation from "@/components/Navigation";
import LocalRecommendations from "@/components/LocalRecommendations";
import Reviews from "@/components/Reviews";
import ContactUs from "@/components/ContactUs";

const Index = () => {
  return (
    <main className="min-h-screen">
      <Navigation />
      <section id="hero">
        <Hero />
      </section>
      <section id="features">
        <Features />
      </section>
      <section id="gallery">
        <Gallery />
      </section>
      <section id="testimonials">
        <Reviews />
      </section>
      <section id="recommendations">
        <LocalRecommendations />
      </section>
      <section id="contact">
        <ContactUs />
      </section>
      <section id="booking">
        <BookingForm />
      </section>
    </main>
  );
};

export default Index;
